import { render } from "./ThresholdPopup.vue?vue&type=template&id=e5b50c32&scoped=true"
import script from "./ThresholdPopup.js?vue&type=script&lang=js"
export * from "./ThresholdPopup.js?vue&type=script&lang=js"

import "./ThresholdPopup.vue?vue&type=style&index=0&id=e5b50c32&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5b50c32"]])

export default __exports__